// Shared gradient-colour scale + difficulty vocabulary. One source of
// truth for the elevation chart, the map route tint, the summary strip,
// the Discover-card pill and the legend.

export const GRADIENT_BANDS = [
  { max: 0.05, color: "#4A8B5A", label: "<5%" },   // green
  { max: 0.08, color: "#D6B338", label: "5–8%" },  // yellow
  { max: 0.12, color: "#D97A2C", label: "8–12%" }, // orange
  { max: Infinity, color: "#C04A2A", label: ">12%" }, // red
];

// Treat downhill the same visually — walkers care about steepness regardless of direction.
export function gradientColor(fraction) {
  const abs = Math.abs(fraction || 0);
  for (const b of GRADIENT_BANDS) {
    if (abs < b.max) return b.color;
  }
  return GRADIENT_BANDS[GRADIENT_BANDS.length - 1].color;
}

export const DIFFICULTY = {
  easy: { label: "Easy", color: "#4A8B5A", bg: "rgba(74,139,90,0.14)" },
  moderate: { label: "Moderate", color: "#D6B338", bg: "rgba(214,179,56,0.18)" },
  hard: { label: "Hard", color: "#D97A2C", bg: "rgba(217,122,44,0.18)" },
  very_hard: { label: "Very hard", color: "#C04A2A", bg: "rgba(192,74,42,0.18)" },
};

export function difficultyMeta(key) {
  return DIFFICULTY[key] || null;
}
